import React, { createContext, useState } from "react";
import all_product from '../Components/Assets/all_product'
import Cart from "../Pages/Cart";

export const ShopContext = createContext(null);
const getDefaultCart = ()=>{
        let cart = {};
        for(let index=0;index<all_product.length+1;index++){
            cart[index] = 0;
        }
        return cart;
    }
const ShopContextProvider = (props) => {

    const [cartItems, setCartItems] = useState(getDefaultCart());
    
    const addToCart = (id) => {
        setCartItems((prev) => ({
            ...prev,
            [id]: prev[id] + 1
        }));
    }
    const removeFromCart = (id) => {
        setCartItems((prev) => ({
            ...prev,
            [id]: prev[id] - 1
        }));
    }

    const getTotalCartAmount = () => {
        let totalAmount = 0;
        for(const item in cartItems)
        {
            if(cartItems[item]>0){
                let itemInfo = all_product.find((product)=>product.id===Number(item))
                totalAmount += itemInfo.new_price * cartItems[item];
            }            
        }
        return totalAmount;
    }

    const getTotalCartItems =() =>{
        let totalItem = 0;
        for (const item in cartItems){
            if(cartItems[item]>0){
                totalItem+=cartItems[item];
            }
        }
        return totalItem;
    }

    const context_value = {getTotalCartAmount,getTotalCartItems,all_product,cartItems,addToCart,removeFromCart};
    return (
        <ShopContext.Provider value={context_value}>
            {props.children}
        </ShopContext.Provider>
    );
}
export default ShopContextProvider;